import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  cardGrid: {
    paddingTop: theme.spacing(2),
    width: '100%',
    height: '100%',
    paddingBottom: theme.spacing(2),
  },
}));

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Nunito', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
  },
  gridPadding: {
    padding: '2px',
  },
  card: {
    height: '100%',
    minHeight: '150px',
    minWidth: '200px',
    display: 'flex',
    flexDirection: 'column',
  },
  cardGrid: {
    paddingTop: '2px',
    width: '100%',
    height: '100%',
    paddingBottom: '2px',
  },

};

export default styles;
